/*
 * @Author: 
 * @Date: 2022-07-22 14:35:57
 * @LastEditors: 
 * @LastEditTime: 2022-07-22 14:36:00
 * @FilePath: /Cup2Supplier/Users/onepisya/Documents/GitHub/jdhl_work/Cup2Market/src/mixins/defer.js
 * @Description: 
 */
export default function (count = 10) {
  return {
    data() {
      return {
        displayPriority: 0
      }
    },

    mounted() {
      this.runDisplayPriority()
    },

    methods: {
      runDisplayPriority() {
        const step = () => {
          requestAnimationFrame(() => {
            this.displayPriority++
            if (this.displayPriority < count) {
              step()
            }
          })
        }
        step()
      },

      defer(priority) {
        return this.displayPriority >= priority
      }
    }
  }
}
